module.exports = __webpack_public_path__ + "static/media/use11_ch02.0761710b.png";